export default __webpack_public_path__ + "static/media/step_C_EN.543535d7.png";